import { render, staticRenderFns } from "./LazyComponentLoader.vue?vue&type=template&id=76eabee9"
import script from "./LazyComponentLoader.vue?vue&type=script&lang=js"
export * from "./LazyComponentLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports